export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-stone-900"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
        <div className="md:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src="/assets/andaz.png"
              alt="Andaz at work"
              className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 border border-amber-500/20 pointer-events-none" />
            <div className="absolute -bottom-6 -right-6 bg-amber-500 text-stone-950 px-6 py-4 hidden md:block">
              <div className="font-display text-3xl leading-none">2yrs</div>
              <div className="text-[10px] tracking-[0.3em] uppercase mt-1">
                Behind the chair
              </div>
            </div>
          </div>
        </div>

        <div className="md:col-span-7">
          <div className="text-[10px] tracking-[0.3em] uppercase text-amber-500/80 mb-4">
            About the barber
          </div>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight text-stone-50 leading-tight">
            Meet <span className="italic text-amber-500">Andaz</span> — the
            hand behind the fade.
          </h2>
          <div className="mt-8 space-y-5 text-stone-300 text-base md:text-lg leading-relaxed">
            <p>
              A UNL engineering freshman by day, private-chair barber by
              night — Andaz has been sharpening his craft for around two
              years. From clean tapers and textured crops to full colour
              work, every appointment starts with a conversation about the
              look you actually want.
            </p>
            <p>
              This isn't a rushed in-and-out shop. It's your chair, your
              hour, your vibe — in his own private space.
            </p>
          </div>
          <div className="mt-10 grid grid-cols-3 border border-stone-800 divide-x divide-stone-800">
            {[
              { n: "2yrs", l: "Cutting hair" },
              { n: "UNL", l: "Engineering major" },
              { n: "1:1", l: "Private chair" },
            ].map((s) => (
              <div key={s.l} className="p-5 md:p-6">
                <div className="font-display text-2xl md:text-3xl text-amber-500">
                  {s.n}
                </div>
                <div className="text-[10px] md:text-xs tracking-[0.2em] uppercase text-stone-400 mt-2">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
